<mat-form-field class="dict-users"  *ngIf="active">
  <mat-label>{{ label }}</mat-label>
  <mat-select  *ngIf="!userFormsPermission"  [disabled]="userPermissionsEditable" [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple" >
    <mat-option>
      <ngx-mat-select-search [formControl]="usersFilterCtrl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono użytkownika">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let user of items" [value]="user.uuid">
      {{user.firstName}} {{user.lastName}} ({{user.username}}) {{role? roleType(user): ''}}
    </mat-option>
  </mat-select>

  <mat-select *ngIf="userFormsPermission"  [disabled]="userPermissionsEditable" [formControl]="control" [required]="required" (selectionChange)="onSelectionChange($event)" [multiple]="multiple" >
    <mat-option>
      <ngx-mat-select-search [formControl]="usersFilterCtrl" placeholderLabel="Wyszukaj..."
                             noEntriesFoundLabel="Nie znaleziono użytkownika">
      </ngx-mat-select-search>
    </mat-option>
    <mat-option *ngFor="let user of items" [value]="user.uuid" >
      {{user.firstName}} {{user.lastName}} ({{user.username}})  {{role? roleType(user): ''}}
    </mat-option>
  </mat-select>

  <button *ngIf="((control.value !== null && !userPermissionsEditable
    && multiple && control.value?.hasOwnProperty('length')
    && control.value.length > 0) || (!multiple && control.value))
    && !required"
          matSuffix
          mat-icon-button
          type="button"
          aria-label="Clear"
          (click)="clearValue(); $event.stopPropagation()">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control.hasError('required')">To pole jest wymagane</mat-error>
</mat-form-field>

<mat-form-field class="dict-users"  *ngIf="!active">
  <mat-label>{{ label }}</mat-label>
  <mat-select  [disabled]="true" >
  </mat-select>
</mat-form-field>
